import React, { useState, useEffect } from "react";

const Btn = ({ onClick, children, disabled = false }) => (
  <button
    onClick={onClick}
    disabled={disabled}
    style={{
      background: disabled ? "#9ca3af" : "#bb1ccc",
      color: "white",
      border: "none",
      borderRadius: "6px",
      padding: "10px 28px",
      cursor: disabled ? "not-allowed" : "pointer",
      fontWeight: "700",
      fontSize: "14px",
      transition: "opacity 0.15s",
    }}
  >
    {children}
  </button>
);

const AssessmentFooter = ({
  sections, currentSectionIdx, reportIdx,
  reportUnlocked, onPrev, onNext, onSubmit, onSaveAsDraft
}) => {
  const isFirst = currentSectionIdx === 0;
  const isLast = currentSectionIdx === sections.length - 1;
  const isReportLocked = currentSectionIdx === reportIdx && !reportUnlocked;

  const [showError, setShowError] = useState(false);

  useEffect(() => {
    if (!showError) return;
    const timer = setTimeout(() => setShowError(false), 3000);
    return () => clearTimeout(timer);
  }, [showError]);

  const handleSubmitClick = () => {
    if (!reportUnlocked) {
      setShowError(true);
      return;
    }
    onSubmit();
  };

  return (
    <>
      {/* Toast notification - right side */}
      {showError && (
        <div style={{
          position: "fixed", top: "20px", right: "20px", zIndex: 9999,
          background: "#fff", border: "1px solid #f59e0b",
          borderLeft: "4px solid #e53e3e", borderRadius: "6px",
          padding: "12px 16px", boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
          fontSize: "13px", fontWeight: "600", color: "#e53e3e",
          display: "flex", alignItems: "center", gap: "8px"
        }}>
⚠️ Please complete all required fields before submitting        </div>
      )}

      <div style={{ position: "fixed", bottom: 0, left: "5%", right: "5%", background: "white", borderTop: "1px solid #eee", padding: "12px 24px", display: "flex", justifyContent: "space-between", alignItems: "center", zIndex: 100, boxShadow: "0 -2px 8px rgba(0,0,0,0.06)" }}>
        <div style={{ display: "flex", gap: "10px" }}>
          {!isFirst && <Btn onClick={onPrev}>PREV</Btn>}
          {!isReportLocked && (
            <Btn onClick={isLast ? handleSubmitClick : onNext}>
              {isLast ? "SUBMIT" : "NEXT"}
            </Btn>
          )}
        </div>
        <Btn onClick={onSaveAsDraft}>SAVE AS DRAFT</Btn>
      </div>
    </>
  );
};

export default AssessmentFooter;